<template>
    <div>
        <input :value="value" :checked="active" type="radio" class="absolute invisible" />
        <slot>
            <div
                class="inline-block w-full px-4 text-center bg-blue-500 rounded-sm cursor-pointer"
                :class="[
                    active ? 'active bg-blue-500 text-white' : 'bg-grey-100 text-blue-600',
                    variant || 'py-4',
                    { 'cursor-not-allowed opacity-50': disabled }
                ]"
                @click="select(value)"
            >
                {{ text }}
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number, Boolean],
            required: true
        },
        text: {
            type: [String, Number],
            default: ''
        },
        active: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        variant: {
            type: [Boolean, String],
            default: false
        }
    },

    methods: {
        select(value) {
            if (!this.disabled) this.$emit('input', value);
        }
    }
};
</script>

<style scoped>
.highlight-yellow:hover {
    @apply bg-yellow-500;
}

.active.highlight-yellow {
    @apply bg-yellow-500 text-blue-500;
}
</style>
